import * as THREE from 'three';

export class Rock {
  static create(): THREE.Mesh {
    const rockGeometry = new THREE.DodecahedronGeometry(
      Math.random() * 1.5 + 0.5,
      0
    );
    
    const positionAttribute = rockGeometry.getAttribute('position');
    const vertex = new THREE.Vector3();
    
    for (let i = 0; i < positionAttribute.count; i++) {
      vertex.fromBufferAttribute(positionAttribute, i);
      vertex.x += (Math.random() - 0.5) * 0.1;
      vertex.y += (Math.random() - 0.5) * 0.1;
      vertex.z += (Math.random() - 0.5) * 0.1;
      positionAttribute.setXYZ(i, vertex.x, vertex.y, vertex.z);
    }
    
    const rockMaterial = new THREE.MeshPhongMaterial({
      color: 0x888888,
      flatShading: false
    });
    
    return new THREE.Mesh(rockGeometry, rockMaterial);
  }
}